import {createAsyncThunk} from '@reduxjs/toolkit';
import ApiUtils from '../../../utils/apiUtils';
import base_url from '../../../baseUrls';
import {initialServerState} from '../initialStates';

export const editCompany = createAsyncThunk(
  'company/editCompany',
  async ( props, thunkAPI) => {
    try {
      const authToken = await ApiUtils.getAccessToken();
      if(!authToken) {
        return thunkAPI.rejectWithValue('AUTH_ERROR');
      }
      //console.log('Edit company payload', props);

      const response = await fetch(
        `${base_url.api}companies/edit`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: authToken,
          },
          body: JSON.stringify(props),
        }
      );
      let data = await response.json();
      //console.log('getCurrentCompanyData response',response, response.status === 200);
      if (response.status === 200) {
        return {...data.data};
      } else {
        console.log('Rejected with', data);
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const editCompanyReducer = {
  [editCompany.pending]: (state)=>{
    state.isFetching = true;
  },
  [editCompany.fulfilled]: (state, {payload})=>{
    // console.log('fulfilled payload', payload)
    //const company = payload.company;
    const newState = {...state, ...initialServerState};
    //console.log('new state', newState)
    return newState;
  },
  [editCompany.rejected]: (state, {payload}) => {
    state.isFetching = false;
    state.isError = true;
    state.errorMessage = payload?.message;
  },
};